// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
    margin-left: 250px;
    padding: 24px; /* Больше пространства вокруг контента */
    width: calc(100% - 250px); /* Ширина с учетом sidebar */
    background: #FFFFFF;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Добавлена тень для контейнера */
}

/* Table styles */
.sos-table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    border-radius: 8px; /* Закругленные углы таблицы */
    overflow: hidden; /* Для предотвращения выхода границ */
}

.sos-table th,
.sos-table td {
    padding: 16px;
    text-align: left;
    border-bottom: 1px solid #DFE7EF;
    font-size: 16px;
    color: #4B5563;
}

/* Header style */
.sos-table th {
    font-weight: bold;
    background-color: #F9FAFB;
    color: #111827;
}

/* Row styles */
.sos-table tr:hover {
    background-color: #F3F4F6;
    transition: background-color 0.3s ease; /* Плавный переход цвета */
}

/* Empty data message */
.no-data {
    text-align: center;
    padding: 20px;
    color: #6B7280;
    font-size: 16px;
}

/* Button styles */
.view-button {
    padding: 8px 16px;
    background-color: #FF0000;
    color: #FFFFFF;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    transition: background-color 0.3s ease;
}

.view-button:hover {
    background-color: #E60000;
}

/* Модальные стили */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    background-color: #fff;
    padding: 24px;
    border-radius: 8px;
    width: 600px;
    max-width: 90%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); /* Тень для модального окна */
}

.close-button {
    background-color: #FF0000;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 15px;
    font-size: 14px;
    font-weight: bold;
    transition: background-color 0.3s ease;
}

.close-button:hover {
    background-color: #E60000;
}

.map-container {
    margin-top: 20px;
    border-radius: 8px;
    overflow: hidden; /* Предотвращает выход карты за границы */
}
`, "",{"version":3,"sources":["webpack://./src/style/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa,EAAE,wCAAwC;IACvD,yBAAyB,EAAE,4BAA4B;IACvD,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,wCAAwC,EAAE,kCAAkC;AAChF;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB,EAAE,8BAA8B;IAClD,gBAAgB,EAAE,qCAAqC;AAC3D;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,yBAAyB;IACzB,sCAAsC,EAAE,0BAA0B;AACtE;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,yCAAyC,EAAE,6BAA6B;AAC5E;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB,EAAE,yCAAyC;AAC/D","sourcesContent":[".dashboard-container {\n    margin-left: 250px;\n    padding: 24px; /* Больше пространства вокруг контента */\n    width: calc(100% - 250px); /* Ширина с учетом sidebar */\n    background: #FFFFFF;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Добавлена тень для контейнера */\n}\n\n/* Table styles */\n.sos-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-family: Arial, sans-serif;\n    border-radius: 8px; /* Закругленные углы таблицы */\n    overflow: hidden; /* Для предотвращения выхода границ */\n}\n\n.sos-table th,\n.sos-table td {\n    padding: 16px;\n    text-align: left;\n    border-bottom: 1px solid #DFE7EF;\n    font-size: 16px;\n    color: #4B5563;\n}\n\n/* Header style */\n.sos-table th {\n    font-weight: bold;\n    background-color: #F9FAFB;\n    color: #111827;\n}\n\n/* Row styles */\n.sos-table tr:hover {\n    background-color: #F3F4F6;\n    transition: background-color 0.3s ease; /* Плавный переход цвета */\n}\n\n/* Empty data message */\n.no-data {\n    text-align: center;\n    padding: 20px;\n    color: #6B7280;\n    font-size: 16px;\n}\n\n/* Button styles */\n.view-button {\n    padding: 8px 16px;\n    background-color: #FF0000;\n    color: #FFFFFF;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: bold;\n    transition: background-color 0.3s ease;\n}\n\n.view-button:hover {\n    background-color: #E60000;\n}\n\n/* Модальные стили */\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.modal-content {\n    background-color: #fff;\n    padding: 24px;\n    border-radius: 8px;\n    width: 600px;\n    max-width: 90%;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); /* Тень для модального окна */\n}\n\n.close-button {\n    background-color: #FF0000;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 15px;\n    font-size: 14px;\n    font-weight: bold;\n    transition: background-color 0.3s ease;\n}\n\n.close-button:hover {\n    background-color: #E60000;\n}\n\n.map-container {\n    margin-top: 20px;\n    border-radius: 8px;\n    overflow: hidden; /* Предотвращает выход карты за границы */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
